import AutoPrefix from 'utils/auto-prefix';

export default {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || this.easeOutFunction;

    return AutoPrefix.singleHyphened(property) + ' ' +
      duration + ' ' +
      easeFunction + ' ' +
      delay;
  }
};


/** WEBPACK FOOTER **
 ** ./src/utils/transitions.js
 **/